import * as React from 'react';
import {head} from 'ramda';
import Form from 'react-bootstrap/Form';
import {date} from 'ka-erp-data';

const css = require('./head.css').default;

export default function ({data, receivers, onReceiverChange, onDeliverDateChange, onMemoChange}: {
    data: {
        deliverDate: date | null,
        receiver: receiver | null,
        memo: string | null,
    },
    receivers: receiver[],
    onReceiverChange: (receiver: receiver | null) => void,
    onDeliverDateChange: (date: date | null) => void,
    onMemoChange: (memo: string | null) => void,
}) {
    return (
    <div id={css.head}>
        <Form.Group>
            <Form.Label>外註</Form.Label>
            <Form.Control placeholder="外註 (學校名稱、業務代號...)"
                value={data.memo || ''}
                onChange={e => {
                    const text = e.target.value.trim();
                    onMemoChange(text === '' ? null : text);
                }}
            />
        </Form.Group>
        <Form.Group>
            <Form.Label>預計出貨日</Form.Label>
            <Form.Control type='date'
                value={data.deliverDate ? datex.toString(data.deliverDate) : ''}
                onChange={e => {
                    const d = e.target.value;
                    if (d === '') {
                        onDeliverDateChange(null);
                    } else {
                        onDeliverDateChange(date.fromDate(new Date(Date.parse(d))));
                    }
                }}/>
        </Form.Group>
        {(() => {
            if (receivers.length > 0) {
                return (
                <Form.Group>
                    <Form.Label>指送客戶</Form.Label>
                    <Form.Select
                        value={data.receiver?.id || ''}
                        onChange={e => {
                            onReceiverChange(head(receivers.filter(i => i.id === e.target.value)) || null);
                        }}
                    >
                        <option value=''>無</option>
                        {receivers.map(i => <option key={i.id} value={i.id}>{i.name} ({i.address})</option>)}
                    </Form.Select>
                </Form.Group>);
            }
        })()}
    </div>);
}

namespace datex {
    export function toString(date: date) {
        const [y, m, d] = [date.year, date.month, date.date].map(i => i.toString());
        return `${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`;
    }
}

type receiver = {
    id: string,
    name: string | null,
    address: string,
}

type product = {
    id: string,
    name: string,
    online: boolean,
    memo: string | null,
}

type item = {
    product: string,
    qty: number,
    memo: string | null,
}
